import { useSelector } from 'react-redux';
import FJGuideModal from './FJGuideModal';
import FJModal from '../FJModal';

const FJGuideModalContainer = () => {
    const data = useSelector(state => state.guideModals.data);
    const isShow = useSelector(state => state.guideModals.isShow);

    return (
        <FJModal visible={isShow}>
            <FJGuideModal data={data} />
        </FJModal>
    );
};
export default FJGuideModalContainer;
